import type { Contact } from './ContactDataManagementTypes';
import { ContactListFlag, ContactType } from './ContactDataManagementTypes';

export function isNewAddressAllowed(flags?: ContactListFlag[]): boolean {
    if (!flags) {
        return true;
    }
    return !flags.includes(ContactListFlag.ADDRESS_NOT_ALLOWED);
}

export function isNewPhoneAllowed(flags?: ContactListFlag[]): boolean {
    if (!flags) {
        return true;
    }
    return !flags.includes(ContactListFlag.PHONE_NOT_ALLOWED);
}

export function isNewEmailAllowed(flags?: ContactListFlag[]): boolean {
    if (!flags) {
        return true;
    }
    return !flags.includes(ContactListFlag.EMAIL_NOT_ALLOWED);
}

export function isAnyNewContactRestricted(flags?: ContactListFlag[]): boolean {
    if (!flags) {
        return false;
    }

    return (
        flags.includes(ContactListFlag.ADDRESS_NOT_ALLOWED) &&
        flags.includes(ContactListFlag.PHONE_NOT_ALLOWED) &&
        flags.includes(ContactListFlag.EMAIL_NOT_ALLOWED)
    );
}

export const isContactAddress = ({ type }: Contact): boolean => type === ContactType.ADDRESS;
export const isContactPhone = (contact?: Contact): boolean => contact?.type === ContactType.PHONE;
export const isContactEmail = ({ type }: Contact): boolean => type === ContactType.EMAIL;
